import { Heading } from '../../styledComponents';
import styles from './StatCard.module.css';

type StatCardProps = {
  title: string;
  value: string;
  icon: string;
};

export default function StatCard({ title, value, icon }: StatCardProps) {
  return (
    <div className={styles.statCard}>
      <div className={styles.leftDiv}>
        <Heading as="h4" fontSize="18px" fontWeight="500" lineHeight="24px">
          {title}
        </Heading>
        <p>{icon}</p>{' '}
      </div>
      <div className={styles.rightdiv}>
        <p>{value || 'NA'}</p>
      </div>
    </div>
  );
}
